var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoGreenOnLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "BRITE",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    xmlSpace: "preserve",
    viewBox: "240 445.58 520.43 110.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " \t.st0{fill:#45BDA6;} ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_766_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_7703_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7712_",
    className: "st0",
    d: "M417,500.2c5.6-1.8,9.2-6.3,9.2-12.1c0-10.7-9-15.4-18.5-15.4c-8.2,0-15,0-23.1,0v3.7h4.4  H405h2.6c7,0,14.4,3.5,14.4,11.7c0,8.1-7.1,10.2-13.9,10.2H405h-16.1h-4.4v4.1h4.4c6.4,0,11.9,0,18.2,0c0.4,0,0.7,0,1.1,0  c7.6,0,15.6,3.1,15.6,11.9c0,9-9.1,10.6-16.2,10.6h-0.6h-18.2h-4.4v4.2c8.2,0,14.9,0,23.1,0c9.7,0,20.5-3.1,20.5-14.8  C428.1,507.9,424.1,502.2,417,500.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7711_",
    className: "st0",
    d: "M522.3,490.3c-0.1-8.8-6.3-17.6-18.5-17.6c-8.3,0-16.5,0-24.8,0v4h4.4H499h4.7  c9.4,0,13.9,6.9,13.8,13.5c-0.1,7.9-4.4,13.5-14.3,13.5h-20v0h-4.4v25.5h4.4v-21.4h15.4l19.5,21.4h5.7L504,507.6  C516.3,507.6,522.4,499.5,522.3,490.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7710_",
    className: "st0",
    points: "571.5,529.2 575.8,529.2 575.8,473.5 571.5,473.9  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7709_",
    x: 571.5,
    y: 472.7,
    className: "st0",
    width: 4.3,
    height: 4
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7708_",
    className: "st0",
    points: "626.8,476.7 647.2,476.7 647.2,476.7 651.5,476.7 651.5,476.7 671.9,476.7   671.9,472.8 626.8,472.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7707_",
    x: 647.2,
    y: 503.6,
    className: "st0",
    width: 4.4,
    height: 25.6
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7706_",
    className: "st0",
    points: "748.4,525 724.7,525 720.5,525 720.5,529.2 760.4,529.2 760.4,525  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7705_",
    className: "st0",
    points: "724.7,502.7 757.8,502.7 757.8,498.8 744.9,498.8 724.7,498.8 720.5,498.8   720.5,502.8 724.7,502.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7704_",
    className: "st0",
    points: "744.9,476.9 759.4,476.9 759.4,472.7 720.5,472.7 720.5,476.9 724.7,476.9  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5585_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_6891_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_7701_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7702_",
    className: "st0",
    d: "M272.2,472.4c0,2.9-2.4,5.3-5.3,5.3c-2.9,0-5.3-2.4-5.4-5.3c0-2.9,2.4-5.3,5.3-5.3  C269.8,467.1,272.2,469.5,272.2,472.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_7698_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7699_",
    className: "st0",
    d: "M318.2,529c0-2.9,2.4-5.3,5.3-5.3c3,0,5.4,2.4,5.4,5.4c0,2.9-2.4,5.3-5.4,5.3  C320.6,534.4,318.2,532,318.2,529z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_7696_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7697_",
    className: "st0",
    d: "M310.6,469.1c-3,0-5.4-2.4-5.4-5.4c0-2.9,2.4-5.3,5.3-5.3c2.9,0,5.3,2.4,5.3,5.3  C315.9,466.7,313.5,469.1,310.6,469.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_7581_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7690_",
    className: "st0",
    d: "M323.5,477.8c-2.5,0-5.4-2.3-5.3-5.4c0.1-2.9,2.4-5.3,5.4-5.3c2.9,0,5.3,2.4,5.3,5.4  C328.9,475.4,326.5,477.8,323.5,477.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_7579_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7580_",
    className: "st0",
    d: "M332.2,521.4c-3,0-5.3-2.4-5.3-5.4c0-3,2.4-5.3,5.4-5.3c3,0.1,5.3,2.5,5.3,5.4  C337.5,519.1,335.1,521.4,332.2,521.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_7171_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7578_",
    className: "st0",
    d: "M263.6,516.1c0,2.9-2.4,5.3-5.3,5.3c-2.9,0-5.3-2.4-5.3-5.3c0-2.9,2.4-5.3,5.3-5.3  C261.2,510.7,263.5,513.1,263.6,516.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_7169_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7170_",
    className: "st0",
    d: "M310.6,532.4c3,0,5.3,2.4,5.3,5.4c0,2.9-2.5,5.3-5.4,5.3c-2.9-0.1-5.3-2.4-5.3-5.3  C305.2,534.7,307.6,532.4,310.6,532.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_7167_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7168_",
    className: "st0",
    d: "M279.8,469.1c-2.9,0-5.3-2.4-5.3-5.4c0-2.9,2.5-5.3,5.4-5.3c2.9,0,5.3,2.5,5.3,5.3  C285.2,466.7,282.8,469.1,279.8,469.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_7165_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7166_",
    className: "st0",
    d: "M258.3,480.1c2.9,0,5.3,2.4,5.3,5.4c0,2.9-2.4,5.3-5.4,5.3c-2.9,0-5.3-2.5-5.3-5.4  C252.9,482.4,255.3,480.1,258.3,480.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_7163_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7164_",
    className: "st0",
    d: "M261.7,529.2c-0.2-3.7,2.9-5.5,5.2-5.5c2.9,0,5.3,2.4,5.3,5.3c0,2.9-2.4,5.3-5.3,5.3  C264,534.4,261.7,532.1,261.7,529.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_7161_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7162_",
    className: "st0",
    d: "M255.2,506.1c-3,0-5.3-2.4-5.3-5.3c0-3,2.4-5.3,5.3-5.3c3,0,5.3,2.3,5.3,5.3  C260.5,503.7,258.1,506.1,255.2,506.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_7159_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7160_",
    className: "st0",
    d: "M340.6,500.8c0,3-2.4,5.3-5.4,5.3c-2.9,0-5.3-2.3-5.3-5.3c0-2.9,2.3-5.3,5.3-5.4  C338.3,495.4,340.6,497.7,340.6,500.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_7157_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7158_",
    className: "st0",
    d: "M326.9,485.4c0-3,2.4-5.3,5.3-5.3c3,0,5.3,2.4,5.3,5.3c0,2.9-2.4,5.4-5.3,5.3  C329.3,490.7,326.9,488.4,326.9,485.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_7155_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7156_",
    className: "st0",
    d: "M280,532.4c2.9,0,5.3,2.5,5.3,5.4c0,2.9-2.5,5.3-5.4,5.3c-3,0-5.3-2.4-5.3-5.4  C274.6,534.7,277,532.4,280,532.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_6894_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6899_",
    className: "st0",
    d: "M300.5,460.7c0,3-2.4,5.3-5.3,5.3c-3,0-5.3-2.4-5.3-5.3c0-3,2.4-5.3,5.4-5.3  C298.2,455.4,300.6,457.8,300.5,460.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_6892_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6893_",
    className: "st0",
    d: "M300.5,540.7c0,3-2.3,5.3-5.4,5.3c-2.9,0-5.2-2.3-5.3-5.3c0-3,2.3-5.3,5.3-5.3  C298.2,535.4,300.5,537.8,300.5,540.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_6887_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6888_",
    className: "st0",
    d: "M294.9,530c-16.7-0.3-29.2-13.5-28.9-30.5c0.3-15.6,14-28.4,29.9-28.1  c16.2,0.3,28.8,13.8,28.5,30.4C324.1,517.3,310.6,530.3,294.9,530z M291.6,497.7c-2.7-0.4-4.3,0.9-5.2,3.1  c-1.3,3,0.1,6.7,3.2,8.7c5.8,3.7,14.2-0.7,15.2-7.9c1.4-10.1-8.4-18-18.4-14.9c-6.9,2.2-11.4,6.9-12.5,14.1  c-1.2,8.1,1.7,14.7,8.4,19.4c9.9,6.9,23.7,4.6,31.2-4.9c7.6-9.6,6.5-23.4-2.6-31.7c-8.4-7.7-22.1-8.2-30-0.8  c1.3-0.5,2.1-0.8,2.9-1.1c5.7-2,11.3-1.7,16.7,1.2c6.9,3.6,11.3,12,10.1,19c-1.4,8.1-6.7,13.6-14.7,14.5  c-5.2,0.6-9.6-1.2-12.8-5.5c-2.9-3.9-3.6-8.3-1.5-12.9c1.9-4,6.1-6.4,10.4-5.9c3.7,0.4,6.5,2.9,7.2,6.5c0.5,2.7-0.3,5-2.8,6.3  c-2,1-4.2,1.1-5.7-0.8C288.9,501.8,289.9,499.7,291.6,497.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_6883_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6884_",
    className: "st0",
    d: "M295.2,556c-30.5,0-55.2-24.8-55.2-55.2s24.8-55.2,55.2-55.2c30.5,0,55.2,24.8,55.2,55.2  S325.7,556,295.2,556z M295.2,450.3c-27.8,0-50.4,22.6-50.4,50.4c0,27.8,22.6,50.4,50.4,50.4c27.8,0,50.4-22.6,50.4-50.4  C345.6,472.9,323,450.3,295.2,450.3z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGreenOnLeft);
export default __webpack_public_path__ + "static/media/LogoGreen(OnLeft).c20d4424bc03c19f756d22fd90297d05.svg";
export { ForwardRef as ReactComponent };